import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const faqs = [
  {
    letter: "W",
    word: "Who",
    q: "Who is W for?",
    a: "W is for anyone who wants a premium, private, and social email service outside of Big Tech.",
  },
  {
    letter: "W",
    word: "What",
    q: "What does W actually do?",
    a: "W gives you an AI-powered inbox, a premium email address and more ways to connect — for free.",
  },
  {
    letter: "W",
    word: "When",
    q: "When can I start using it?",
    a: "W is launching soon. Reserve your handle today and we'll send you an exclusive invite the moment your inbox is ready.",
  },
  {
    letter: "W",
    word: "Where",
    q: "Where can I find W?",
    a: "W is currently in development, with private alpha launching soon. We will be available worldwide at wemail.xyz.",
  },
  {
    letter: "W",
    word: "Why",
    q: "Why now?",
    a: "Email hasn't changed much in decades, yet it remains the backbone of how we communicate. W is a fresh take on email — with a unique domain and a social inbox built for how people actually connect today.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <h2 className="font-serif-display text-pearl text-3xl sm:text-5xl tracking-tight leading-[1.05]">
            The <span className="italic text-bone">5 W&apos;s</span>
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="w-full"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-hairline"
            >
              <AccordionTrigger className="py-6 text-left text-pearl text-[17px] sm:text-[19px] font-medium tracking-tight hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-ash text-[15px] leading-relaxed pb-6 pr-2">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
